import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { Dialog } from './dialog';
import styles from './auth.scss';

type LoginProgressProps = DefaultContainerProps;

export class LoginProgressComponent extends React.Component<LoginProgressProps, any> {
  public static statePath: string = STATE.app;

  public render() {
    const {translation} = this.props;
    return (
      <Dialog>
        <div>
          <div className={`${styles.iconAsBg} ${styles.spinLoader}`} />
          <div className={`${styles.fadeInUp}`}>
            <h1>{translation.loginProgressDialogTitle}</h1>
            <p>{translation.loginProgressTitle}</p>
          </div>
        </div>
      </Dialog>
    );
  }
}

const container = containerFactory(LoginProgressComponent, null);
export { container as LoginProgress };
